import { render } from "./DigitalTransfromScroll.vue?vue&type=template&id=33c72153&scoped=true&lang=pug"
import script from "./DigitalTransfromScroll.vue?vue&type=script&lang=ts"
export * from "./DigitalTransfromScroll.vue?vue&type=script&lang=ts"

import "./DigitalTransfromScroll.vue?vue&type=style&index=0&id=33c72153&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-33c72153"

export default script